(ns frontend.ui.page.lp-report-editor.step-6-publishing-queue.sub
  (:require
   [frontend.ui.page.lp-report-editor.sub :as editor-sub]))

(def report-tab-path (conj editor-sub/editor-path :publishing-queue-report-tab))

